import EntityColors from '@/atoms/colors/Entity';
import ChartType from '@/shared/enums/ChartType';
import EntityType from '@/shared/enums/EntityType';
import SortType from '@/shared/enums/SortType';
import { EntityMetric, SortOrder } from '@/lib/enums';

export default function defaultChartSettings({
  designId,
  revisionId,
  designType,
  designEntityId,
}) {
  const color = EntityColors[EntityType.ROLE].primary;

  return {
    chartType: ChartType.VERTICAL_BAR,
    condition: null,
    displaySettings: {
      showMetricValues: false,
    },
    id: 'default-settings',
    title: '',
    sort: {
      type: SortType.NUMERIC,
      direction: SortOrder.DESC,
    },
    xAxis: [
      {
        designId,
        revisionId,
        designType,
        designEntityId,
        ids: null,
        entityType: EntityType.ROLE_TYPE,
        subType: null,
        color,
      },
    ],
    yAxis: {
      metric: EntityMetric.HOURS,
    },
  };
}
